import React from "react";
import * as ReactDOMClient from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

import reportWebVitals from "./reportWebVitals";

import './i18nextConf';

import apiClient from "./services/api";
import { getToken } from "./services/user";

import store from "./store/index";
import { toggleMessageOpen } from "./store/actions/Message";

import App from "./App";

import "./index.css";

let token = getToken();

const container = document.getElementById('root');

const root = ReactDOMClient.createRoot(container);

const render = () => {
    root.render(
        <Provider store={store}>
            <Router>
                <App />
            </Router>
        </Provider>
    );
};

if (token) {
    apiClient.defaults.headers.common["Authorization"] = `${token}`;
    apiClient.post("api/me").then((response) => {
        if(response.data.success) {
            store.dispatch({ type: "SET_LOGIN", payload: response.data.data });
            render();
        }
    })
    .catch(error => {
        store.dispatch(toggleMessageOpen('Session expired', 'error'));
        store.dispatch({ type: "SET_LOGOUT" });

        if(!alert('Your session expired')) {
            render();
        }
    });

    apiClient.post("api/heartbeat").catch((error) => {
        console.error(error?.response?.data?.message);
    });
}
else
{
    render();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
